// console.log(API.SERVICE)
import Form from '../../../../public/core/inc/form';
import { HandlebarRender } from '../../../../public/core/inc/handlebarForm';
var schedulerForm = new Form();
const _ = require('lodash');
import moment from 'moment';
let Handlebars = require('handlebars');

schedulerForm.wrapper = '#bmi-form';
schedulerForm.url = API.BMI;
schedulerForm.method = 'POST';


schedulerForm.beforeSubmit=()=>{  
    let weight = $('[name="weight').val(),
    height=$('[name="height').val();
    let bmi = Math.round(weight/(Math.pow((height/100),2)) *100 ) /100;
    schedulerForm.data.bmi_index=bmi;
}

schedulerForm.afterDone = (data) => {	

    $('html, body').animate({ scrollTop: $('.section-home-services').offset().top-100}, 1000);
    $('.qodef-section-subtitle').html(`Chỉ số BMI của bạn là :  <b class="title_bmi"> ${data.data.bmi_index}</b>`)
}
schedulerForm.submit();
// item-tag
$(document).ready(function () {  
    

})

